import { GraphQLRequestProps, request } from '@repo/ui/src/utils/graphql-request';
import { QueryResponse, searchProductListItems } from '@api/product/getProductListData';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import useSWRImmutable from 'swr/immutable';

interface Props {
  skus: Array<string>;
}

const fetcher = async (props: GraphQLRequestProps) => {
  const { searchProductListItems } = await request<QueryResponse>(props)!;
  return searchProductListItems.hits;
};

const useProductList = ({ skus }: Props) => {
  const { locale, currency } = useCurrentUrl();
  return useSWRImmutable(
    {
      document: searchProductListItems,
      variables: {
        filter: { sku: skus },
        pageSize: skus?.length,
        currency,
      },
      locale,
    },
    fetcher,
  );
};

export default useProductList;
